import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { DEFAULT_BORDER_COLOR } from './constants';
export default /*#__PURE__*/_defineComponent({
  __name: 'AssignmentStatusOutput',
  props: {
    status: {
      default: function _default() {
        return {
          title: 'Неизвестно',
          borderColor: DEFAULT_BORDER_COLOR
        };
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var styleVariables = computed(function () {
      return {
        '--background-color': props.status.backgroundColor,
        '--border-color': props.status.borderColor,
        '--text-color': props.status.color
      };
    });
    return {
      __sfc: true,
      props: props,
      styleVariables: styleVariables
    };
  }
});